import { Route, Routes } from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Navbar from "./Shared/Navbar";
import Footer from "./Shared/Footer";
import AddStudent from "./Components/Dashboard/AddStudent/AddStudent";
import ManageStudent from "./Components/Dashboard/ManageStudent/ManageStudent";
import EditStudentData from "./Components/Dashboard/EditStudentData/EditStudentData";
import Login from "./Components/LoginProcess/Login";
import Registration from "./Components/LoginProcess/Registration";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ViewStudent from "./Components/Dashboard/ViewStudent/ViewStudent";

function App() {
  return (
    <div className="App">
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Dashboard></Dashboard>}>
          <Route index element={<AddStudent></AddStudent>}></Route>
          <Route
            path="/manageStudent"
            element={<ManageStudent></ManageStudent>}
          ></Route>
          <Route
            path="/editStudent/:id"
            element={<EditStudentData></EditStudentData>}
          ></Route>
          <Route
            path="/viewStudent/:id"
            element={<ViewStudent></ViewStudent>}
          ></Route>
        </Route>
        <Route path="/login" element={<Login></Login>}></Route>
        <Route
          path="/registration"
          element={<Registration></Registration>}
        ></Route>
      </Routes>
      <Footer></Footer>
      <ToastContainer></ToastContainer>
    </div>
  );
}

export default App;
